// link between tab and sub menu on mobile device

let subMenus = document.querySelectorAll('.mobile-nav__sublink-container');
let tabs = document.querySelectorAll('.mobile-nav__tab .mobile-nav__item');
tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    subMenus.forEach(subMenu => {
      subMenu.classList.remove('mobile-nav__sublink-container--active');
    });
    tabs.forEach(tab => {
      tab.classList.remove('mobile-nav__item--active');
    });
    let target = tab.getAttribute('data-target');
    document.getElementById(target).classList.add('mobile-nav__sublink-container--active');
    tab.classList.add('mobile-nav__item--active');
  });
});